@if (this.productLine$ | async; as productLine) {
  <div
    class="tab-pane fade flex-even active show"
    id="insuranceDocuments"
    role="tabpanel"
    aria-labelledby="insuranceDocuments-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        @if (productLine.productCategoryInsuranceDocuments?.length != 0) {
          <table
            class="table table-striped border-bottom"
            >
            <thead>
              <tr>
                <th>
                  <a translate>INSURANCEDOCUMENT_LBL_NAME</a>
                </th>
                <th class="text-center">
                  <a translate>INSURANCEDOCUMENT_LBL_MANDATORY</a>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (
                insuranceDocument of productLine.productCategoryInsuranceDocuments
                ; track
                insuranceDocument) {
                <tr
                  class="row-action"
                  >
                  <td>{{ insuranceDocument.name }}</td>
                  <td class="text-center">
                    <input
                      type="checkbox"
                      [checked]="insuranceDocument.isMandatory"
                      disabled
                      />
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    </div>
  }
